var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatLtr = function SvgChatLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.268 35c.957 0 1.732.672 1.732 1.5 0 .81-.74 1.47-1.667 1.499l-.065.001H33.732C32.775 38 32 37.328 32 36.5c0-.81.74-1.47 1.667-1.499l.065-.001zM58.25 45c.967 0 1.75.672 1.75 1.5 0 .81-.748 1.47-1.684 1.499l-.065.001H41.749C40.783 48 40 47.328 40 46.5c0-.81.748-1.47 1.684-1.499l.065-.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M81 15a7 7 0 0 1 7 7v41.077a7 7 0 0 1-7 7H50l-16.479 14.1a2 2 0 0 1-3.3-1.52v-12.58H19a7 7 0 0 1-7-7V22a7 7 0 0 1 7-7zm.5 5.5-63.117-.007a1 1 0 0 0-.993.884l-.007.116L17.5 63.5a1 1 0 0 0 .883.993l.117.007h17v11l12.283-11H81.5a1 1 0 0 0 .993-.883l.007-.117v-42a1 1 0 0 0-.883-.993z",
    clipRule: "evenodd"
  })));
};
export default SvgChatLtr;